.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #fff;
  width: min(900px, 92vw);
  max-height: 84vh;
  border-radius: 3px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.title {
  font-size: 20px;
  font-weight: 600;
  color: #111;
}

.close {
  border: 0;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: var(--btn-secondary);
}

.body {
  padding: 0 20px;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}
.footer {
  padding: 12px 20px;
  border-top: 1px solid #eee;
  text-align: right;
}
